<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ 'Edit FNB Label' }}</div>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="label_name"
                type="text"
                name="labelname"
                id="labelname"
                v-validate="'required'"
              />
              <label>{{ 'FnB Label Name' }}</label>
            </div>
            <Tooltip :title="$t('fnb_label_tooltip')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('labelname')">{{
              errors.first("labelname")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="label_short_code"
                type="text"
                name="labelshortname"
                id="labelshortname"
                v-validate=""
              />
              <label
                >{{ 'Label Short Name' }}</label
              >
            </div>
            <Tooltip :title="$t('label_short_name_tooltip')" />
          </div>
          <p class="error_message"></p>
        </div>

         <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedType ? 'shift-up' : ''">{{ 'Type' }}</label>
              <multiselect
                      v-model="selectedType"
                      @select="onSelectType($event)"
                      :placeholder="'Select Label Type'"
                      :options="TypeList"
                      label="type_name"
                      track-by="type_id"
                      :multiple="false"
                      name="mltype"
                      id="mltype"
                      select-label="Select"
                      deselect-label="Remove"
                    ></multiselect>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="label_is_active"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-12">
          <h5 class="mb-2">Translations</h5>
          <div class="row">
            <div
              class="col-lg-6 col-xl-4 align-self-center mb-4"
              v-for="(language, langIndex) in languagesToShow"
              :key="langIndex"
            >
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    type="text"
                    name="en-trans"
                    v-model="language.label_name"
                    placeholder="."
                  />
                  <label>{{ language.lang_name }}</label>
                </div>
                <Tooltip :title="`Enter ${language.lang_name} Translation`" />
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="fnb-labels"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import TranslationsContainer from "@/components/Partials/translationsFields.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    TranslationsContainer
  },
  data() {
    return {
      TypeList: [
        {
          type_id: 1,
          type_name: 'Size'
        },
      ],
      selectedType: '',
      type_id: 1,
      btenable: false,
      label_name: "",
      label_id: null,
      label_is_active: "Y",
      label_short_code: "",
      submitted: false,
      translationsObj: {},
      LabelData: []
    };
  },
  computed: {
    ...mapGetters(["getGlobalOptions"]),
    languagesToShow: function() {
      let languages = [];
      console.log("this.LabelData", this.LabelData);
      if (
        this.getGlobalOptions &&
        this.getGlobalOptions.length > 0 &&
        this.LabelData.length > 0
      ) {
        let kiosk_langs_obj = this.getGlobalOptions.find(
          x => x.go_key === "KIOSK_LANGUAGE"
        );

        if (kiosk_langs_obj) {
          try {
            let kiosk_langs = JSON.parse(kiosk_langs_obj.go_value);

            if (kiosk_langs && kiosk_langs.length > 0) {
              kiosk_langs
                .filter(x => x.lang_name && x.iso_2)
                .map(x => {
                  let Array1 = this.LabelData[0].translation_data.filter(y => {
                    return y.lang_id == x.lang_id;
                  });
                  console.log("Array1", Array1);
                  if (Array1.length > 0) {
                    x["lang_id"] = Array1[0].lang_id;
                    x["lang_name"] = Array1[0].lang_name;
                    x["iso_2"] = Array1[0].iso_2;
                    x["label_name"] = Array1[0].label_name;
                  } else {
                    x["lang_id"] = x.lang_id;
                    x["lang_name"] = x.lang_name;
                    x["iso_2"] = x.iso_2.toLowerCase();
                    x["label_name"] = "";
                  }
                });

              languages = kiosk_langs;
            }
          } catch (err) {
            console.log("error in parsing kiosk languages");
          }
        }
      }

      console.log("languagesToShow =>>> ", languages);

      return languages;
    }
  },
  beforeMount() {
    const { id } = this.$route.query;
    if (id) {
      this.label_id = id;
      this.getSingleMovieLabel(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    onSelectType(type) {
      this.type_id = type.type_id;
      this.selectedType = type;
    },
    OnFinalSubmit: function(redirect) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          if(!this.selectedType) {
            return this.$toasted.show('Please Select Label Type')
          } else {
          let payload = {
            label_name: this.label_name,
            label_short_code: this.label_short_code,
            label_id: this.label_id,
            type_id: this.type_id,
            type_name:
              this.TypeList.filter(x => x.type_id == this.type_id)[0]
                ? this.TypeList.filter(x => x.type_id == this.type_id)[0].type_name
                : '',
            label_is_active: this.label_is_active,
            LabelContent: this.languagesToShow
          };

          MasterService.EditFnbLabel(payload)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.resetForm();
                this.$toasted.show(data.message);
                if (redirect) {
                  this.$router.push({
                    path: "/master/fnb-labels"
                  });
                }
                this.submitted = false;
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
        }
      });
    },

    getSingleMovieLabel(labelId) {
      let payload = {
        label_id: labelId
      };

      MasterService.GetSingleFnbLabel(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.TypeList = [...new Map([...this.TypeList, ...data.types].map((item, key) => [item['type_id'], item])).values()]

            if (data.Records.length > 0) {
              this.label_name = data.Records[0].label_name;
              this.label_short_code = data.Records[0].label_short_code;
              this.label_id = data.Records[0].label_id;
              this.type_id = data.Records[0].type_id;
              this.label_is_active = data.Records[0].label_is_active;
              this.LabelData = data.Records;
              this.selectedType = this.TypeList.find((x) => x.type_id == data.Records[0].type_id)
            } else {
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          } else {
            console.log("Error:", data.message);
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          console.log("Error:", err);
        });
    },

    resetForm: function() {
      this.label_name = "";
      this.label_is_active = "Y";
      this.label_short_code = "";
      this.languagesToShow.map(x => {
        x.label_name = "";
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/FNBLabelComponents/editFNBLabel.vue